// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__areWG","content":"PageLoader_content__D0kMA"};